import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  type SxProps,
  styled,
  type Theme,
  Typography,
} from '@mui/material';
import { type ReactNode, useState } from 'react';

const StyledAccordion = styled(Accordion)`
  width: 100%;
  &.MuiAccordion-root {
    margin: 0;
  }
  &.MuiAccordion-root::before {
    display: none;
  }
  & .MuiAccordionSummary-root,
  & .MuiAccordionDetails-root {
    padding: 0;
  }
  & .MuiAccordionSummary-root,
  & .MuiAccordionSummary-root.Mui-expanded,
  & .MuiAccordionSummary-content,
  & .MuiAccordionSummary-content.Mui-expanded {
    min-height: 0;
    padding: 0;
    margin-top: 0;
  }
`;

interface CollapsibleProps {
  label: string;
  children?: ReactNode;
  onToggle?: (isExpanded: boolean) => void;
  sx?: SxProps<Theme>;
}

export function Collapsible({
  label,
  children,
  onToggle,
  sx,
}: CollapsibleProps) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const isExpanded = !isCollapsed;

  const toggleIsCollapsed = () => {
    onToggle?.(!isExpanded);
    setIsCollapsed((prev) => !prev);
  };

  return (
    <StyledAccordion expanded={isExpanded} onClick={toggleIsCollapsed}>
      <AccordionSummary sx={sx}>
        <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
          <Typography variant="h5" component="span" sx={{ color: 'inherit' }}>
            {label}
          </Typography>
          {isExpanded ? (
            <KeyboardArrowUp sx={{ color: 'inherit', fontSize: 'small' }} />
          ) : (
            <KeyboardArrowDown sx={{ color: 'inherit', fontSize: 'small' }} />
          )}
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        onClick={(e) => {
          // prevent collapse when clicking on content
          e.stopPropagation();
        }}
      >
        {children}
      </AccordionDetails>
    </StyledAccordion>
  );
}
